import React from 'react'
import { Route, Switch } from 'react-router-dom'
import loadable from '@loadable/component'
import { checkPropTypes } from 'prop-types'

export const DefaultTrendPage = loadable(() => import('../pages/DefaultTrendPage'))
export const SoccerWorldCupTrend = loadable(() => import('../../templates/Trends/SoccerWorldCupTrend'))
export const RugbyWorldCupTrend = loadable(() => import('../../templates/Trends/RugbyWorldCupTrend'))
// export const SaincTrend = loadable(() => import('../../templates/Trends/SaincTrend'))
// export const CoronaVirusTrend = loadable(() => import('../../templates/Trends/CoronaVirusTrend'))
// export const Elections2021Trend = loadable(() => import('../../templates/Trends/Elections2021Trend'))
export const Elections2024Trend = loadable(() => import('../../templates/Trends/Elections2024Trend'))

const Trends = (p) => (
  <Switch>
    {/* <Route path='/trends/:trend(xxx)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/xxx'
        sectionLabel='#xxx'
        title='xxx'
        description='xxx'
      />} /> */}
    <Route path='/trends/:trend(best-of-2022)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/best-of-2022'
        sectionLabel='#BestOf2022'
        title='Best of 2022 | News | IOL'
        description='2022 was a year of many highs and lows. It was a year where the news made us cry, made us laugh and sometimes angry. Here is the best news stories carried by IOL in 2022.'
      />} />
    <Route path='/trends/:trend(make-money-2023)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/make-money-2023'
        sectionLabel='#MakeMoney2023'
        title='Make Money 2023 | Wealth | IOL'
        description="Are you looking to make money in 2023? Look no further! IOL is dedicated to helping you reach your financial goals. Whether you're looking to start a business, invest in the stock market, or simply save more money, we've got you covered. On this trends page you will find tips, resources, and motivation to help you make money in the new year."
      />} />
    <Route path='/trends/:trend(pitbull-ban)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/pitbull-ban'
        sectionLabel='#PitbullBan'
        title='Pitbull Ban | News | IOL'
        description="A call have the pitbull breed banned was launched by the Sizwe Kupelo Foundation in 2022 through writing to government departments and a petition. Though the departments of health, agriculture and police have yet to respond to Kupelo's letters, the petition has since garnered more than 50 000 signatures and growing as of November 2022."
      />} />
    <Route path='/trends/:trend(national-strike)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/national-strike'
        sectionLabel='#NationalStrike'
        title='National Strike | News | IOL'
        description='The Public Servants Association and members have embarked on a strike that will affect the activities of government departments, especially home affairs and transport, from 10 November. Unions have demanded a raise of as much as 10%. Inflation in South Africa is currently 7.5%. Government has offered 3% increase and is not budging.'
      />} />
    <Route path='/trends/:trend(gun-violence)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/gun-violence'
        sectionLabel='#GunViolence'
        title='Gun Violence | News | IOL'
        description="Gun crimes in South Africa are increasing at an alarming rate. An average of 23 people are shot and killed in South Africa every day, according to the country's annual crime statistics. The estimated total number of guns (both licit and illicit) held by civilians in South Africa is between 3,700,000 and 7,200,000"
      />} />
    <Route path='/trends/:trend(matric-2022)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/matric-2022'
        sectionLabel='#Matric2022'
        title='Matric 2022 | Education | IOL'
        description='The National Senior Certificate (NSC) examinations commonly referred to as “matric” has become an annual event of major public significance. It not only signifies the culmination of twelve years of formal schooling but the NSC examinations is a barometer of the health of the education system.'
      />} />
    <Route path='/trends/:trend(fifa-world-cup-2022)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/fifa-world-cup-2022'
        sectionLabel='#FifaWorldCup2022'
        template={SoccerWorldCupTrend}
        title='Fifa World Cup 2022 | Sport | IOL'
        description="The 2022 FIFA World Cup is scheduled to take place in Qatar from 20 November to 18 December 2022. This will be the first World Cup ever to be held in the Arab world and the second World Cup held entirely in Asia after the 2002 tournament in South Korea and Japan. In addition, the tournament will be the last to involve 32 teams, with an increase to 48 teams scheduled for the 2026 tournament in the United States, Mexico, and Canada. Due to Qatar's intense summer heat, this World Cup will be held from late-November to mid-December, making it the first tournament not to be held in May, June, or July and to take place in the northern autumn."
      />} />
    <Route path='/trends/:trend(sandton-terror-threat)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sandton-terror-threat'
        sectionLabel='#SandtonTerrorThreat'
        title='Sandton Terror Threat | News | IOL'
        description='The US Government has issued an alert for a possible terror attack in Sandton, Johannesburg for the weekend of October 28.In a statement, the US Embassy says it received information that terrorists may be planning to attack and target large gatherings of people. The US embassy is advising staff to avoid crowds of people and public gatherings in the area this weekend.'
      />} />
    <Route path='/trends/:trend(war-on-women)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/war-on-women'
        sectionLabel='#WarOnWomen'
        title='War On Women | News | IOL'
        description='The murder of women and girls, in acts of femicide, is the most extreme form of gender-based violence (GBV). South Africa is known for having one of the highest rates of femicide in the world with hardly a day passing without another case highlighted in the media.'
      />} />
    <Route path='/trends/:trend(water-crisis)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/water-crisis'
        sectionLabel='#WaterCrisis'
        title='Water Month | News | IOL'
        description="South Africa, one of the driest places on earth is facing water threats on muliple fronts with Day Zero approaching the city of Gqeberha and now water cuts in Johannesburg. Coupled with this is a brewing sewage crisis in KwaZulu-Natal. Across South Africa, water stress is a priority problem, but with no single cause there is no single solution. Each area experiences water issues caused to different degrees by excessive use, growing demand, pollution, theft, thirsty plants, inadequate infrastructure, and poor practices. Solving these issues not only requires financial investment but also a change in attitude. South Africa cannot support the water lifestyle some residents consider to be their right, fueling a water consumption that's 35 percent above the global average."
      />} />
    <Route path='/trends/:trend(heritage-month)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/heritage-month'
        sectionLabel='#HeritageMonth'
        title='Heritage Month | News | IOL'
        description='September marks the annual Heritage Month in South Africa. Heritage Month recognises aspects of South African culture which are both tangible and intangible: creative expression such as music and performances, our historical inheritance, language, the food we eat as well as the popular memory.'
      />} />
    <Route path='/trends/:trend(pothole-crisis)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/pothole-crisis'
        sectionLabel='#PotholeCrisis'
        title='Pothole Crisis | News | IOL'
        description='South Africans may have their differences but one issue that unites us all are the potholes on our roads which has become a national crisis. Potholes and the time it takes to repair them go at the very heart of service delivery and is the one metric that determines how efficient or inneficient our local governments are.'
      />} />
    <Route path='/trends/:trend(zulu-king)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/zulu-king'
        sectionLabel='#ZuluKing'
        title='Zulu King | News | IOL'
        description='King Misuzulu kaZwelithini will perform a ritual, known as Ukungena Esibayeni (entering the kraal), at Enyokeni royal palace on August 20 before his official coronation. According to Zulu culture, customs and traditions, when the king passes on, there is no vacuum. King Zwelithini named his wife Queen Mantfombi Dlamini Zulu as regent, which meant that the successor to the Zulu Kingdom would come from her house. When the queen died King Misuzulu was pronounced as the heir to the throne.'
      />} />
    <Route path='/trends/:trend(book-fair)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/book-fair'
        sectionLabel='#BookFair'
        title='Book Fair | News | IOL'
        description="The Durban International Book Fair convenes in Africa's only UNESCO city of literature. 'Unlocked & Unleashed' is a tribute to the storytellers keeping the word alive under the most testing conditions. #DIBF2022 is designed as a global marketplace for readers, creatives, authors, academicians, literacy NGOs, language promoters, publishers and dealmakers. The setting is the spectacular Sibaya Sun hilltop complex surrounded by rolling green hills and flanked by the majestic Indian Ocean."
      />} />
    <Route path='/trends/:trend(under-pressure)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/under-pressure'
        sectionLabel='#UnderPressure'
        title='Under Pressure | News| Business| IOL'
        description='South Africans are under pressure from rising fuel, food, and electricity hikes. Added to this, the Reserve Bank has raised the interest rate again and more hikes are predicted in the months ahead, squeezing already strained South Africans to the max. These stories explore how South Africans are coping under the pressure of it all.'
      />} />
    <Route path='/trends/:trend(tavern-killings)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/tavern-killings'
        sectionLabel='#Tavern Killings'
        title='Tavern Killings | News | IOL'
        description='South Africans are reeling following three shootings that claimed the lives of at least 21 people at taverns across South Africa on the weekend of July 10. Questions about the sale of alcohol and the emergence of multiple taverns in one precinct in townships are in the spotlight.'
      />} />
    <Route path='/trends/:trend(hollywoodbets-durban-july)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/hollywoodbets-durban-july'
        sectionLabel='#HollywoodbetsDurbanJuly'
        title='Durban July | News | Sport | Horse Racing | IOL'
        description="On the first Saturday of every July nearly 60 000 people head towards Greyville to experience 'July Fever'. And it's not all about the horses! It is a fashion and entertainment extravaganza where everybody wants to be seen. The Durban July is one of South Africa's premier horse racing events."
      />} />
    <Route path='/trends/:trend(making-ends-meet)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/making-ends-meet'
        sectionLabel='#MakingEndsMeet'
        title='Making Ends Meet | News | IOL'
        description='South Africans are feeling the pinch: high unemployment rates, rising petrol costs and rapidly rising interest rates plus food prices shooting through the roof and load shedding. Every aspect of South Africans lives are hit by a struggling post-Covid economy. We give hope to our readers, showing them how to make ends meet, how to find side hustles and jobs, how to stretch their salaries and how to keep a roof over their heads and food on the table, plus how to adapt to rising transport costs. Making ends meet is a way of giving hope to South Africans facing incredibly difficult financial constraints and giving them positive and simple ways to deal with the constraints placed on their money.'
      />} />
    <Route path='/trends/:trend(eastern-cape-tragedy)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/eastern-cape-tragedy'
        sectionLabel='#EasternCapeTragedy'
        title='Eastern Cape Tragedy | News | IOL'
        description='Twenty one mysteriously died inside the Enyobeni tavern in East London on Sunday June 26.Officials have ruled out a stampede as the cause of the deaths.Most of the victims, some as young as 13, were found dead inside Enyobeni tavern in East London.Seventeen died inside the bar, while four died in hospital. The victims included 13 boys and eight girls.'
      />} />
    <Route path='/trends/:trend(petrol-price)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/petrol-price'
        sectionLabel='#PetrolPrice'
        title='Petrol Price | News | IOL'
        description='There are two main constituents of the prices of controlled petroleum products: The external factors – the dollar price of the product on world markets multiplied by the US$/R exchange rate. The internal factors – the rand-based retail and oil company marketing margins, transport costs and taxes and levies'
      />} />
    <Route path='/trends/:trend(farmgate)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/farmgate'
        sectionLabel='#FarmGate'
        title='Farmgate | News | IOL'
        description='President, Cyril Ramaphosa, is facing the most serious personal challenge of his four years in power after claims he tried to cover up the theft of millions of US dollars hidden at his Phalala Phalala game farm. The scandal – labelled Farmgate by South African media – could potentially derail Ramaphosa\’s efforts to win a second term in power.'
      />} />
    <Route path='/trends/:trend(loadshedding)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/loadshedding'
        sectionLabel='#LoadShedding'
        title='Loadshedding | News | IOL'
        description='When the demand for electricity exceeds the available supply, planned supply interruptions may have to be carried out. This is called load shedding. It is a controlled way of rotating the available electricity between all Eskom customers. According to the power utility, affected areas are not interrupted for more than two hours at a time, and in most cases customers can be informed of interruptions in advance. It is also done on a rotational basis. Shortages on the electricity system unbalance the network, which can cause it to collapse; by rotating the load in a planned and controlled manner, the system remains stable.'
      />} />
    <Route path='/trends/:trend(youthmonth)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/youthmonth'
        sectionLabel='#YouthMonth'
        title='Youth Month | News | IOL'
        description='The commemoration of Youth Day marks the anniversary of the 16 June Soweto uprising. In 1975 protests started in African schools after a directive from the then Bantu Education Department that Afrikaans had to be used on an equal basis with English as a language of instruction in secondary schools. The issue, however, was not so much the Afrikaans, as the whole system of Bantu education which was characterised by separate schools and universities, poor facilities, overcrowded classrooms and inadequately trained teachers. On 16 June 1976 more than 20 000 pupils from Soweto began a protest march. In the wake of clashes with the police, and the violence that ensued during the next few weeks, approximately 700 hundred people, many of them youths, were killed and property destroyed.'
      />} />
    <Route path='/trends/:trend(guptas)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/guptas'
        sectionLabel='#Guptas'
        title='Guptas | News | IOL'
        description="The Gupta family is a wealthy Indian-born family with business interests in South Africa, whose most notable members are brothers Ajay, Atul, and Rajesh 'Tony' Gupta—as well as Atul's nephews Varun, and US-based Ashish and Amol. The family owns a business empire spanning computer equipment, media, and mining"
      />} />
    <Route path='/trends/:trend(senzo-meyiwa)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/senzo-meyiwa'
        sectionLabel='#SenzoMeyiwa'
        title='Senzo Meyiwa | News | IOL'
        description="Senzo Robert Meyiwa was a South African professional footballer who played as a goalkeeper and captain for both Orlando Pirates in the Premier Soccer League, and the South Africa national team. He was shot and killed in a home invasion on 26 October 2014"
      />} />
    <Route path='/trends/:trend(monkey-pox)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/monkey-pox'
        sectionLabel='#Monkeypox'
        title='Monkey Pox Outbreak | Symptoms Treatment & News | IOL'
        description="Read more about the Monkey Pox outbreak in South Africa. Monkeypox is a viral disease that occurs mostly in central and western Africa. It is called monkeypox because it was first identified in laboratory monkeys."
      />} />
    <Route path='/trends/:trend(jobs)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/jobs'
        sectionLabel='#Jobs'
        title='Jobs Online  | Job Search | Find Jobs | Careers South Africa | IOL'
        description="Attention all job seekers find jobs and career opportunities online.  Get the latest employment news and career advice from industry experts on IOL"
      />} />
    <Route path='/trends/:trend(fifth-wave)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/fifth-wave'
        sectionLabel='#FifthWave'
        title='Fifth Wave | Covid News | 5th Wave | IOL'
        description="A rise in test positivity rates and the presence of the SARS-CoV-2 virus in the country’s wastewater, has raised the alarms for the arrival of a possible fifth, winter wave in South Africa."
      />} />
    <Route path='/trends/:trend(my-fellow-south-africans)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/my-fellow-south-africans'
        sectionLabel='#MyFellowSouthAfricans'
        title='My Fellow South Africans | News IOL'
        description=''
      />} />
    <Route path='/trends/:trend(hillary-gardee)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/hillary-gardee'
        sectionLabel='#HillaryGardee'
        title='Hillary Gardee | News | IOL'
        description='Hillary Gardee, the daughter of prominent EFF politician, Godrich Gardee was found murdered in in bushes 45km outside Mbombela in April 2022. Her murder and the circumstances surrounding it sent shockwaves throughout SA.'
      />} />
    <Route path='/trends/:trend(state-of-sa-hospitals)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/state-of-sa-hospitals'
        sectionLabel='#StateOfSAHospitals'
        title='State of SA Hospitals | Health | IOL News'
        description="At some point every South African, whether directly or indirectly will come in contact with South Africa's public heath system. What will they face when they do encounter it? A caring health system or one that is sick?"
      />} />
    <Route path='/trends/:trend(kzn-floods)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/kzn-floods'
        sectionLabel='#KZNFloods'
        title='KZN Floods | Weather | Durban Floods | IOL News'
        description='KwaZulu-Natal is prone to storms that often bring heavy rains that lead to flooding. Many people die and are often displaced during these weather events due to river banks bursting and people building homes in places that wash away.'
      />} />
    <Route path='/trends/:trend(lockdown-lifted)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/lockdown-lifted'
        sectionLabel='#LockdownLifted'
        title='Lockdown Lifted | COVID-19 / Novel Coronavirus | IOL News'
        description='On Monday, April 4, 750 days after South Africa went into lockdown to curb the spread of the Covid-19 pandemic, President Cyril Ramaphosa announced an end to the National State of Disaster which deregulated a raft of laws that governed how we lived during the pandemic'
      />} />
    <Route path='/trends/:trend(righttobank)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/righttobank'
        sectionLabel='#RightToBank'
        title='RightToBank'
        description="Everything you need to know as to why the banks are being challenged and why everyone in South Africa has an equal right to bank"
      />} />
    <Route path='/trends/:trend(shane-warne)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/shane-warne'
        sectionLabel='#ShaneWarne'
        banner={'/images/australia-banner.jpg'}
        title='Shane Warne Dies | Tributes News and Updates'
        description="Former Australia cricketer Shane Warne dies at the age of 52. Warne's management released a statement saying he had died of a suspected heart attack in Koh Samui, Thailand."
      />} />
    <Route path='/trends/:trend(russia-ukraine-conflict)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/russia-ukraine-conflict'
        sectionLabel='#RussiaUkraineConflict'
        title='Russia Ukraine Conflict | Russo-Ukrainian War 2022'
        description='Russia has launched an invasion attacking Kiev, in what US President Joe Biden called a "premeditated war" against Ukraine.'
      />} />
    <Route path='/trends/:trend(campus-disruptions)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/campus-disruptions'
        sectionLabel='#CampusDisruptions'
        title='Campus Disruptions | Updates & News'
        description="South Africa's higher education campuses are a hotbed for disruption driven by disgruntled students aligned to various student organisations who contest issues ranging from fees, access to student accommodation and student allowances. Most campus disruptions occur from February when the higher education academic year starts"
      />} />
    <Route path='/trends/:trend(fuel-price-increase)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/fuel-price-increase'
        sectionLabel='#FuelPriceIncrease'
        title='Fuel Price Increase | South African Petrol Price Hike Updates'
        description="South Africa's fuel price is determined by monthly adjustments of the import price of basic fuel and is based on the Rand/US dollar exchange rate and international prices of petrol. The price is determined using a formula, which on any given day yields a certain price, and it is this change in value that determines how much South Africans pay for fuel."
      />} />
    <Route path='/trends/:trend(typhoid)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/typhoid'
        sectionLabel='#Typhoid'
        title='Typhoid Fever | Typhoid Bacteria | Symptoms and Treatment'
        description="Typhoid fever is a bacterial infection that can spread throughout the body, affecting many organs. Without prompt treatment, it can cause serious complications and can be fatal. It's caused by a bacterium called Salmonella typhi, which is related to the bacteria that cause salmonella food poisoning. Symptoms include fatigue, headache, nausea, abdominal pain, and constipation or diarrhea."
      />} />
    <Route path='/trends/:trend(fourthwaveover)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/fourthwaveover'
        banner={'/images/sona2022-banner.jpg'}
        sectionLabel='#FourthWaveOver'
        title='The End of the Covid19 4th Wave in South Africa | Latest News, Developments & Updates'
        description="South Africa's Covid-19 Fourth Wave, driven mostly by the Omicron Variant officially ended in February when the government relaxed a raft of lockdown regulation rules."
      />} />
    <Route path='/trends/:trend(sona2022)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sona2022'
        sectionLabel='#SONA2022'
        title='Sona2022 | Latest News, Developments & Updates'
        description='South Africa prepares for the countdown to The State of the Nation Address. Follow @IOL for all the SONA updates, news, stories, pictures, and more.'
      />} />
    <Route path='/trends/:trend(veganuary)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/veganuary'
        title='Veganuary | Latest News and Developments'
        description=''
      />} />
    <Route path='/trends/:trend(matric2021)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/matric2021'
        banner={'/images/matric2021-banner.jpg'}
        title='Matric 2021 | Latest Matric Exam News and Stories'
        description='Everything you need to know about the Grade 12 matric exams of 2021 as IOL shares news and inspirational stories from around the country.'
      />} />
    <Route path='/trends/:trend(battle-for-the-metros)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/battle-for-the-metros'
        title='The Battle for the Metros | IOL News'
        description='With multi-party democracy taking place in many local councils, district municipalities and metros, The Battle For the Metros is unfolding with drama, tension and twists and turns'
      />} />
    <Route path='/trends/:trend(de-klerk-death)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/de-klerk-death'
        title='Former president FW de Klerk Dies | News Tributes and History | IOL News'
        description="Former president and Nobel Peace prize winner, FW de Klerk dies at age 85. Commemorating the life and times of South Africa's last apartheid president."
      />} />
    <Route path='/trends/:trend(plantbasedcooking)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/plantbasedcooking'
        banner={'/images/plant-based-cooking-banner.jpg'}
        sectionLabel='none'
        title='Plant-based Cooking | IOL Lifestyle'
        description='IOL Lifestyle explores plant-based meal plans and recipes to help you understand and enjoy flexitarian, vegetarian, or vegan food and the benefits of consuming plant-based foods for your health and wellness.'
      />} />
    <Route path='/trends/:trend(t20worldcup)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/t20worldcup'
        banner={'/images/T20-World-Cup-banner.jpg'}
        sectionLabel='none'
        title='T20 World Cup Cricket Series | Latest News and Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(elections-2021)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/elections-2021'
        // template={Elections2021Trend}
        title='Elections 2021 in South Africa | Latest News and Updates | IOL'
        description='IOL gives you the latest on the 2019 national Find all the latest and breaking election 2021 news, updates, and headlines on IOL.'
      />} />
    <Route path='/trends/:trend(elections-2024)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/elections-2024'
        template={Elections2024Trend}
        title='Elections 2024 in South Africa | Latest News and Updates | IOL'
        description='IOL gives you the latest on the 2024 national elections. Find all the latest and breaking election 2024 news, updates, and headlines on IOL.'
      />} />
    <Route path='/trends/:trend(truecrime)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/truecrime'
        title='TrueCrime | IOL News'
        description='Shocking real life crimes from across SA. Relooking at old cases and unpacking them in detail.'
      />} />
    <Route path='/trends/:trend(tembisa10)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/tembisa10'
        title='Tembisa 10 Investigation | News and Updates | IOL News'
        description='Read everything you need to know about the Tembisa 10 decuplets.'
      />} />
    <Route path='/trends/:trend(uselections2020)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/uselections2020'
        title='Latest US Presidential Election 2020 | IOL News'
        banner={'/images/us-elections-2020-banner.png'}
        description='Get developing news content, comment and analysis on the 59th United States presidential election between the republican`s Donald Trump and the democrat`s Joe Biden.'
      />} />
    <Route path='/trends/:trend(risemzansi)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/risemzansi'
        title='Rise Mzansi | IOL'
        banner={'/images/risemzansi-banner.jpg'}
        description=''
      />} />
    <Route path='/trends/:trend(ultimatesa)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ultimatesa'
        title='Ultimate South African Cultural Experience | IOL'
        sectionLabel='none'
        banner={'/images/ultimatesa-banner.jpg'}
        description='We feature the very best of South African culture and experiences through news, features and profiles of our talented people, food, fashion, towns, beaches and icons.'
      />} />
    <Route path='/trends/:trend(localislekker)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/localislekker'
        title='Local and Proudly South African Stories | IOL News'
        sectionLabel='none'
        banner={'/images/localislekker-banner.jpg'}
        description='Local is lekker, and IOL loves celebrating all things South African. Get the latest news stories, feature articles, events coverage and commentary this Heritage Month.'
      />} />
    <Route path='/trends/:trend(sais2020)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sais2020'
        banner={'/images/sais2020-banner.jpg'}
        sectionLabel='none'
        title='South African Innovation Summit 2020 Updates | IOL News'
        description='Get the latest news and commentary on the SA Innovation Summit. Find everything you need to know about SA`s startup community, tech and digital innovations.'
      />} />
    <Route path='/trends/:trend(womensmonth)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/womensmonth'
        banner={'/images/womensmonth-banner.png'}
        title='Women`s Month Latest and Developing Stories | IOL News'
        description='Celebrate the month of August with content and articles focused on issues pertaining to women in South Africa and across the world. Get event updates and commentary.'
      />} />
    <Route path='/trends/:trend(durbanjuly)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/durbanjuly'
        title='Latest Durban July News, Fashion and Race Updates | IOL News'
        description='Held annually at the Greyville Racecourse, we have all you need to know about the annual Vodacom Durban July. Get race results, fashion coverage, and commentary.'
      />} />
    <Route path='/trends/:trend(mandeladay)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mandeladay'
        title='Latest Mandela Day News Stories and Updates | IOL News'
        description='Stay up-to-date on what organisations and people in SA and around the world are doing for their 67 minutes of Madiba Magic through pictures, videos and opinion pieces.'
      />} />
    <Route path='/trends/:trend(level3)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/level3'
        title='Level 3 South African Lockdown Latest News Updates  | IOL'
        description='IOL has up-to-date stories and commentary on Level 3 national lockdown sanctioned by the South African Government to curb the worldwide coronavirus outbreak.'
      />} />
    <Route path='/trends/:trend(essentialservices)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/essentialservices'
        title='Covid-19 Essential Services News and Developments | IOL News'
        description='Get the latest on essential services offered by the South African government, businesses and companies during the nation-wide lockdown to manage the Coronavirus outbreak.'
      />} />
    <Route path='/trends/:trend(avbob)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/avbob'
        title='AVBOB | Holistic Wellness and Lifestyle | IOL'
        description='We encourage South Africans to make better lifestyle choices with the best life-hacks, healthy living tips and money management advice for a long and fulfilling life.'
      />} />
    <Route path='/trends/:trend(blackfriday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/blackfriday'
        title='Black Friday 2020 | Latest News, Deals, Developments Updates | IOL'
        banner={'/images/blackfriday-trend-banner.png'}
        description='"Catch the latest updates on BlackFriday. Follow #BlackFriday with @IOL for all the most recent, updates, results, pictures and videos.'
      />} />
    <Route path='/trends/:trend(sainc)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sainc'
        // template={SaincTrend}
        title='SAINC | IOL'
        description='SAINC'
      />} />
    <Route path='/trends/:trend(statecaptureinquiry)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/statecaptureinquiry'
        title='State Capture Inquiry | Latest News, Developments & Updates | IOL'
        description='Watch The State Capture Inquiry live feed on IOL. Get developing news stories on witnesses testimonies, commentary on the Zondo commission.'
      />} />
    <Route path='/trends/:trend(trump)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/trump'
        sectionLabel='#trumpimpeachment'
        banner={'/images/trump-impeachment-banner.jpg'}
        title='Donald Trump Impeachment | Latest News, Developments & Updates | IOL'
        description='The historic impeachment trial of the 45th President of the United States of America, Donald Trump, began on January 21st 2020. IOL has developing stories and commentary.'
      />} />
    <Route path='/trends/:trend(coronavirus)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/coronavirus'
        // template={CoronaVirusTrend}
        banner={'/images/coronavirus-banner.png'}
        title='Corona Virus | Latest News, Developments & Updates | IOL'
        description='We have up-to-date stories and commentary on the Coronavirus outbreak. Originating in Wuhan, China, the virus has spread worldwide with over 100 deaths reported.'
      />} />
    <Route path='/trends/:trend(myheart)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/myheart'
        banner={'/images/myhearthero-banner.png'}
        title='MyHeart | Latest News, Developments & Updates | IOL'
        description='February is the month of love. This Valentine`s month, IOL is inviting our readers to tell us who they love and why to stand a chance to win great prizes.'
      />} />
    <Route path='/trends/:trend(iran)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/iran'
        title='IRAN | Latest News, Developments & Updates | IOL'
        description='Get all the latest news stories on the escalating tension between Iran and the United States after President Donald Trump`s order to kill Qassem Soleimani.'
      />} />
    <Route path='/trends/:trend(beautifulnews)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/beautifulnews'
        title='BeautifulNews | Latest News, Developments & Updates | IOL'
        description='IOL has partnered with Beautiful News to bring you positive stories, news, pictures and videos about South Africa and South Africans, telling your stories and driving change.'
      />} />
    <Route path='/trends/:trend(sona)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sona'
        sectionLabel='#SONA2021'
        title='Sona2021 | Latest News, Developments & Updates | IOL'
        description='South Africa prepares for the countdown to The State of the Nation Address. Follow @IOL for all the SONA updates, news, stories, pictures and see what others have to say.'
      />} />
    <Route path='/trends/:trend(backtoschool)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/backtoschool'
        title='BackToSchool | Latest News, Developments & Updates | IOL'
        description='Get the latest back to school news, pictures, videos and tips to get you and your child ready for the new South African school calendar year.'
      />} />
    <Route path='/trends/:trend(csacrisis)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/csacrisis'
        title='CSACrisis | Latest News, Developments & Updates | IOL'
        description='Get the latest and developing news updates, insights, commentary and analysis on the crisis that the SA cricket ruling body CSA is currently facing.'
      />} />
    <Route path='/trends/:trend(dontlookaway)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/dontlookaway'
        banner={'/images/dontlookaway-banner.png'}
        title='DontLookAway | Latest News, Developments & Updates | IOL'
        description='Don`t look away is Independent Media`s 16 days of activism against Gender-based Violence official campaign. Follow IOL for content focused on shedding light on the matter.'
      />} />
    <Route path='/trends/:trend(matricexams)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/matricexams'
        title='Matric Exams | Latest News, Developments & Updates | IOL'
        description='The countdown to the South African National Senior Certificate Matric Exam has begun. Follow IOL for the latest news and announcements, past papers and study guides.'
      />} />
    <Route path='/trends/:trend(mslt20)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mslt20'
        title='MSLT20 | Latest News, Developments & Updates | IOL'
        description='Catch the latest updates on the Mzanzi Super League at Newlands, Cape Town. Follow #mslt20 with @IOL for all the most recent, updates, results, pictures and videos.'
      />} />
    <Route path='/trends/:trend(mtbps)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mtbps'
        title='MTBPS | Latest News, Developments & Updates | IOL'
        description='Get the latest updates on the annual MTBPS delivered by the South African Minister of Finance. Get all the news stories, pictures and opinions from our political analysts.'
      />} />
    <Route path='/trends/:trend(thewineshow)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/thewineshow'
        title='TheWineShow | Latest News, Developments & Updates | IOL'
        description='TOPS at Spar Wine Show is one of South Africa`s biggest wine festivals. Get Pictures, videos, updates, stories, advice and tips on how you can join the festivities on IOL.'
      />} />
    <Route path='/trends/:trend(festiveseason)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/festiveseason'
        title='FestiveSeason | Latest News, Developments & Updates | IOL'
        description='December means Christmas festive season. We have content to help you enjoy and celebrate with your family. Get news updates, safety tips and action attractions.'
      />} />
    <Route path='/trends/:trend(rugbyworldcup)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/rugbyworldcup'
        title='RugbyWorldCup | Latest News, Developments & Updates | IOL'
        description='Get coverage of The Rugby World Cup. IOL brings you the latest updates on the RWC tournament.'
        template={RugbyWorldCupTrend}
      />} />
    <Route path='/trends/:trend(wef)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/wef'
        title='WEFAfrica | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(heritageday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/heritageday'
        title='HeritageDay | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(highschoolsquiz2019)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/highschoolsquiz2019'
        title='HighSchoolsQuiz2019 | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(womenchangingtheworld)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/womenchangingtheworld'
        title='WomenChangingTheWorld | Latest News, Developments & Updates | IOL'
        description='Women Changing The World is IOL`s Women`s Month campaign aimed at celebrating women who have made it their life`s mission to bring positive change in their communities.'
      />} />
    <Route path='/trends/:trend(gavinwatson)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/gavinwatson'
        title='GavinWatson | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(publicprotector)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/publicprotector'
        title='PublicProtector | Latest News, Developments & Updates | IOL'
        description='Get the latest news updates, stories, pictures and videos on the Public Protector as well as announcements and press conferences from the Public Protector`s office.'
      />} />
    <Route path='/trends/:trend(marikana)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/marikana'
        title='Marikana | Latest News, Developments & Updates | IOL'
        description='Get the latest updates, pictures, stories and news on the Marikana 2012 shooting. Stay up-to-date with all the rulings in the Marikana Commission of Inquiry.'
      />} />
    <Route path='/trends/:trend(picinquiry)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/picinquiry'
        title='PICInquiry | Latest News, Developments & Updates | IOL'
        description='Updates news developments, live updates, videos and comment on Justice Mpati Commission of Inquiry on the Public Investment Cooperation in South Africa.'
      />} />
    <Route path='/trends/:trend(ripjohnnyclegg)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ripjohnnyclegg'
        title='RIPJohnnyClegg | Latest News, Developments & Updates | IOL'
        description='South Africa bids farewell to South African artist, anthropologist and activist Johnny Clegg. Get the latest news updates, videos, images and commentary on IOL.'
      />} />
    <Route path='/trends/:trend(sowetoderby)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sowetoderby'
        title='SowetoDerby | Latest News, Developments & Updates | IOL'
        description='The rivalry between Soweto giants Orlando Pirates and Kaizer Chiefs lives on. Catch all the Soweto Derby updates, liqne-ups, fixtures and commentary on IOL.'
      />} />
    <Route path='/trends/:trend(mandeladay2019)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mandeladay2019'
        title='MandelaDay2019 | Latest News, Developments & Updates | IOL'
        description='18 July is Mandela Day. Nelson Mandela International is a day set aside to commemorate the life of the former South African president by doing charitable work.'
      />} />
    <Route path='/trends/:trend(afcon2019)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/afcon2019'
        title='Afcon2019 | Latest News, Developments & Updates | IOL'
        description='Since 1957, AFCON has been bringing African countries together through football. Get the latest African Cup of Nations news, fixtures, results, videos and pictures.'
      />} />
    <Route path='/trends/:trend(cricketworldcup)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/cricketworldcup'
        title='CricketWorldCup | Latest News, Developments & Updates | IOL'
        description='Get the latest ICC Cricket World Cup 2019 news updates, fixtures, video, scores, highlights, interviews and commentary on IOL.'
      />} />
    <Route path='/trends/:trend(sona2019)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sona2019'
        title='SONA2019 | Latest News, Developments & Updates | IOL'
        description='Get the latest news updates on the 2019 State of the Natation Address. IOL keeps you up-to-date with comment and views from top political analysts.'
      />} />
    <Route path='/trends/:trend(youthday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/youthday'
        title='YouthDay | Latest News, Developments & Updates | IOL'
        description='Celebrate South Africa`s Youth Month will IOL. Commemorate the Soweto Uprising on June 16th 1976 with inspiring stories and commentary from South Africans.'
      />} />
    <Route path='/trends/:trend(banyanabanyana)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/banyanabanyana'
        title='BanyanaBanyana | Latest News, Developments & Updates | IOL'
        description='Rally behind South Africa`s National Team Banyana Banyana. Get the latest on match fixtures, highlights, scores and match analysis on IOL.'
      />} />
    <Route path='/trends/:trend(comrades2019)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/comrades2019'
        title='Comrades2019 | Latest News, Developments & Updates | IOL'
        description='IOL has the latest updates and stories on the Ultimate Human Race. Get the list of winners and highlights of the world`s largest and oldest ultramarathon race.'
      />} />
    <Route path='/trends/:trend(durbanfloods)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/durbanfloods'
        title='DurbanFloods | Latest News, Developments & Updates | IOL'
        description='Follow IOL for all the latest updates, news stories, pictures and videos on the floods in the Durban City of KwaZulu-Natal.'
      />} />
    <Route path='/trends/:trend(gameofthrones)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/gameofthrones'
        title='GameOfThrones | Latest News, Developments & Updates | IOL'
        description='Share the Iron Throne with Game of Thrones updates, news and more. IOL keeps you up-to-date with the latest news on the last season of the award-winning HBO series.'
      />} />
    <Route path='/trends/:trend(elections2019)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/elections2019'
        title='Elections2019 | Latest News, Developments & Updates | IOL'
        description='IOL gives you the latest on the 2019 national and provincial general elections, giving you updated announcements and commentary. Find out what South Africa decides.'
      />} />
    <Route path='/trends/:trend(ctjazzfest)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ctjazzfest'
        sectionLabel='#JazzFix2021'
        banner={'/images/jazzfix-banner.jpg'}
        title='JazzFix2021 | Latest News, Developments & Updates | IOL'
        description="Be in the know with the latest celebrity and entertainment news, gossip, pics and videos from the Cape Town International Jazz Festival's 22nd anniversary."
      />} />
    <Route path='/trends/:trend(ethiopianairlines)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ethiopianairlines'
        title='EthiopianAirlines | Latest News, Developments & Updates | IOL'
        description='Get the latest updates on the Ethiopian Airlines Boeing 737 MAX 8 aircraft crash investigations and findings. Follow IOL for more news updates and stories.'
      />} />
    <Route path='/trends/:trend(nigeriadecides)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/nigeriadecides'
        title='NigeriaDecides | Latest News, Developments & Updates | IOL'
        description='IOL has everything you need to know about the 2019 Nigerian General Elections. Follow #nigeriadecides with @IOL for more updates, news, stories, pictures and videos.'
      />} />
    <Route path='/trends/:trend(castersemenya)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/castersemenya'
        title='CasterSemenya | Latest News, Developments & Updates | IOL'
        description='Read the latest news on the South African two-time Olympic Gold Medal-winning athlete, Caster Semenya as well as the developments on the on-going IAAF case.'
      />} />
    <Route path='/trends/:trend(worldcancerday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/worldcancerday'
        title='WorldCancerDay | Latest News, Developments & Updates | IOL'
        description='February 4 is World Cancer Day. Join IOL as we observe International World Cancer Day by bringing awareness through the latest news updates, stories and interviews.'
      />} />
    <Route path='/trends/:trend(zimbabweshutdown)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/zimbabweshutdown'
        title='ZimbabweShutdown | Latest News, Developments & Updates | IOL'
        description='Get the latest news, stories, pictures and videos on the nationwide strike and shutdown in Zimbabwe following the country`s economic state and the increased fuel price.'
      />} />
    <Route path='/trends/:trend(superherosunday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/superherosunday'
        title='SuperHeroSunday | Latest News, Developments & Updates | IOL'
        description='Visit IOL to Kick-off the new rugby season with match updates, commentary and to see what your favourite local rugby team wear their new Marvel superhero-inspired jerseys.'
      />} />
    <Route path='/trends/:trend(sunmet)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sunmet'
        title='SunMet | Latest News, Developments & Updates | IOL'
        description='Held annually at the Kenilworth Racecourse, the Sun Met is a world-class horse racing, fashion and entertainment event. Get the latest news, celebrity scoop and images on IOL.'
      />} />
    <Route path='/trends/:trend(anc107)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/anc107'
        title='ANC107 | Latest News, Developments & Updates | IOL'
        description='Africa`s oldest liberation movement, the ANC celebrated its 107 anniversary in 2019. Stay up-to-date with the latest news, opinion, videos and pictures on IOL.'
      />} />
    <Route path='/trends/:trend(anc108)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/anc108'
        title='ANC108 | Latest News, Developments & Updates | IOL'
        description='Africa`s oldest liberation movement, the African National Congress celebrates its 108th anniversary in Kimberley. IOL has the latest news, opinion and video updates.'
      />} />
    <Route path='/trends/:trend(manunited)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/manunited'
        title='ManUnited | Latest News, Developments & Updates | IOL'
        description='Updates on the English football team Manchester United Football Club. Get the latest match fixtures, scores and highlights with commentary and video.'
      />} />
    <Route path='/trends/:trend(pulemabe)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/pulemabe'
        title='PuleMabe | Latest News, Developments & Updates | IOL'
        description='Get the latest updates on ANC National Spokesperson Pule Mabe`s sexual harassment allegations. Follow IOL for all the developing news and opinion pieces from our analysts.'
      />} />
    <Route path='/trends/:trend(capetown7s)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/capetown7s'
        title='CapeTown7s | Latest News, Developments & Updates | IOL'
        description='Stay tuned on IOL for all the latest updates on the Cape Town 7s. Get match fixtures, highlights, scores and commentary on this international rugby tournament.'
      />} />
    <Route path='/trends/:trend(globalcitizenfestivalsa)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/globalcitizenfestivalsa'
        title='GlobalCitizenFestivalSA | Latest News, Developments & Updates | IOL'
        description='December 2018, the Global Citizen Festival made its way to South African soil. Get insights on the gossip, fashion and music from this star-studded event.'
      />} />
    <Route path='/trends/:trend(californiafires)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/californiafires'
        title='CaliforniaFires | Latest News, Developments & Updates | IOL'
        description='Stay up-to-date with the latest on the deadly seasonal wildfires that happen in the state of California, USA. Watch the latest videos and view collated pictorials.'
      />} />
    <Route path='/trends/:trend(engvrsa)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/engvrsa'
        title='ENGvRSA | Latest News, Developments & Updates | IOL'
        description='The rivalry continues as England and South African tough it out on the field. Get the latest match fixtures, scores, highlights, videos and pictures.'
      />} />
    <Route path='/trends/:trend(vbsbankheist)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/vbsbankheist'
        title='VBSBankHeist | Latest News, Developments & Updates | IOL'
        description='Get all the latest updates on the Venda Building Society (VBS) Mutual Bank heist report findings, liquidation news, and commentary on IOL.'
      />} />
    <Route path='/trends/:trend(courtneypieters)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/courtneypieters'
        title='CourtneyPieters | Latest News, Developments & Updates | IOL'
        description='Everything you need to know about three-year-old Courtney Pieters` rape and murder by a family friend. Get the latest news updates, video and images from court appearances and opinion.'
      />} />
    <Route path='/trends/:trend(zuma)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/zuma'
        title='ZumaCharges | Latest News, Developments & Updates | IOL'
        description='Stay up-to-date with the latest news stories, pictures and videos on former president Jacob Zuma`s corruption charges and court case appearances.'
      />} />
    <Route path='/trends/:trend(patriciadelille)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/patriciadelille'
        title='PatriciaDeLille | Latest News, Developments & Updates | IOL'
        description='Get the latest news updates on Good Party Leader and former Mayor of Cape Patricia De Lille. Follow IOL for pictures, news and videos on the former DA leader.'
      />} />
    <Route path='/trends/:trend(omotosotrial)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/omotosotrial'
        title='OmotosoTrial | Latest News, Developments & Updates | IOL'
        description='Follow IOL for the latest news updates and comments on the rape trial of Nigerian pastor Timothy Omotoso of Jesus Dominion International Church.'
      />} />
    <Route path='/trends/:trend(wozanazo)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/wozanazo'
        title='WozaNazo | Latest News, Developments & Updates | IOL'
        description='The PSL`s Woza Nazo activation is for every South African that loves the beautiful game. Follow IOL for the latest updates on activities, matches and results.'
      />} />
    <Route path='/trends/:trend(titomboweni)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/titomboweni'
        title='TitoMboweni | Latest News, Developments & Updates | IOL'
        description='IOL has the latest updates, news, stories, video and imagery on the former Reserve bank Governor and South African finance minister Tito Mboweini.'
      />} />
    <Route path='/trends/:trend(indonesia)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/indonesia'
        title='Indonesia | Latest News, Developments & Updates | IOL'
        description='Follow IOL of the latest news developments of the 2018 earthquake in Indonesia. Get exclusive video interviews, reporting and comment from IOL.'
      />} />
    <Route path='/trends/:trend(weremember)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/weremember'
        title='WeRemember | Latest News, Developments & Updates | IOL'
        description='2019 Women`s Month, IOL commemorates women who have died violently at the hands of men in South Africa. We Remember is a campaign against gender-based violence.'
      />} />
    <Route path='/trends/:trend(nhlanhlanene)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/nhlanhlanene'
        title='NhlanhlaNene | Latest News, Developments & Updates | IOL'
        description='Find all the updates on former finance minister and ANC MP Nhlanhla Nene`s resignation. Follow IOL for pictures, videos and stories and see what others have to say.'
      />} />
    <Route path='/trends/:trend(jobssummit)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/jobssummit'
        title='JobsSummit | Latest News, Developments & Updates | IOL'
        description='For news updates, and commentary on the government Jobs Summit, resolutions and key take-outs from government, civil, labour and business stakeholders, follow IOL.'
      />} />
    <Route path='/trends/:trend(drosrape)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/drosrape'
        title='DrosRape | Latest News, Developments & Updates | IOL'
        description='Get the latest news updates on the rape case of a twenty-year-old man accused of raping a seven-year-old girl in a toilet of a restaurant in Pretoria.'
      />} />
    <Route path='/trends/:trend(knowyourland)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/knowyourland'
        title='KnowYourLand | Latest News, Developments & Updates | IOL'
        description='Learn more about South Africa`s vibrant culture, history and heritage. For Heritage Month, IOL features videos and stories on some of the country`s untapped destinations.'
      />} />
    <Route path='/trends/:trend(highschoolquiz)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/highschoolquiz'
        title='HighSchoolsQuiz | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(ctmarathon)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ctmarathon'
        title='CTMarathon | Latest News, Developments & Updates | IOL'
        description='Since 2007, Cape Town Marathon has been bringing athletes from all around the world to The Mother City. Get the latest on the routes, registrations and results.'
      />} />
    <Route path='/trends/:trend(crimestats)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/crimestats'
        title='CrimeStats | Latest News, Developments & Updates | IOL'
        description='Get the latest news and analysis of the annual South African crime statistics. Follow #crimestats with @IOL. See what others have to say and share your opinion.'
      />} />
    <Route path='/trends/:trend(comicconafrica)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/comicconafrica'
        title='ComicConAfrica | Latest News, Developments & Updates | IOL'
        description='Since 2018, Comic Con Africa has brought pop culture enthusiasts from around SA together, featuring cosplay, comic books, anime, manga, film & series, games.'
      />} />
    <Route path='/trends/:trend(miguellouw)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/miguellouw'
        title='MiguelLouw | Latest News, Developments & Updates | IOL'
        description='IOL has the latest and developing news stories on the murder case of nine-year-old Miguel Louw from Durban. Get up-to-date and exclusive stories and video.'
      />} />
    <Route path='/trends/:trend(ripmamasobukwe)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ripmamasobukwe'
        title='RIPMamaSobukwe | Latest News, Developments & Updates | IOL'
        description='IOL commemorates the life of unsung South African struggle icon Zondeni Veronica Sobukwe. We keep you updated with the latest on the developing news story.'
      />} />
    <Route path='/trends/:trend(2018zimelections)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/2018zimelections'
        title='2018zimelections | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(trainarson)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/trainarson'
        title='TrainArson | Latest News, Developments & Updates | IOL'
        description='Get the latest news updates, comment, pictures, stories, videos and pictures on the recent train arson incident in and around Cape Town on IOL.'
      />} />
    <Route path='/trends/:trend(kevinanderson)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/kevinanderson'
        title='KevinAnderson | Latest News, Developments & Updates | IOL'
        description='Stay up-to-date with the latest news updates, match fixtures and results of South African professional tennis player Kevin Anderson.'
      />} />
    <Route path='/trends/:trend(fifaworldcup)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/fifaworldcup'
        title='FifaWorldCup | Latest News, Developments & Updates | IOL'
        description='The FIFA World Cup 2018 is upon us. Follow IOL for updates on your favourite qualifying team with pictures, videos and commentary from leading sports analysts.'
      />} />
    <Route path='/trends/:trend(vdj2018)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/vdj2018'
        title='VDJ2018 | Latest News, Developments & Updates | IOL'
        description='Stay updated on one of SA`s largest gathering in our social calendar the, Vodacom Durban July 2018. Follow #vdj2018 on @IOL and see what your favourite celebrities were up to.'
      />} />
    <Route path='/trends/:trend(ashwinwillemse)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ashwinwillemse'
        title='AshwinWillemse | Latest News, Developments & Updates | IOL'
        description='Get the latest on latest former Springbok rugby player and SuperSport commentator and analyst, Ashwin Willemse walked off set after an incident with fellow commentators.'
      />} />
    <Route path='/trends/:trend(nbaafricagame)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/nbaafricagame'
        title='NBAAfricaGame | Latest News, Developments & Updates | IOL'
        description='Find out more about the official launch of the NBA Africa League. With the up-date reports on games, scores, highlights, pictures and videos on IOL.'
      />} />
    <Route path='/trends/:trend(120pretorianews)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/120pretorianews'
        title='120PretoriaNews | Latest News, Developments & Updates | IOL'
        description='Independent Media`s Pretoria News celebrates 120 years of existence. Join us as we go back through the history books for this special occasion.'
      />} />
    <Route path='/trends/:trend(vanbreda)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/vanbreda'
        title='VanBreda | Latest News, Developments & Updates | IOL'
        description='Keep up-to-date with the triple axe murder case of the van Breda family murder and the conviction of murderer and family member Henri van Breda.'
      />} />
    <Route path='/trends/:trend(uclfinal)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/uclfinal'
        title='UCLfinal | Latest News, Developments & Updates | IOL'
        description='IOL Sport has the latest updates on the UEFA Champions League final news, highlights, video and opinions from reputable sports commentators.'
      />} />
    <Route path='/trends/:trend(mosqueattack)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mosqueattack'
        title='MosqueAttack | Latest News, Developments & Updates | IOL'
        description='Get the latest updates, pictures, stories and news on the recent mosque attacks around the world. Follow #mosqueattack on IOL to stay in the know.'
      />} />
    <Route path='/trends/:trend(mothersday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mothersday'
        title='MothersDay | Latest News, Developments & Updates | IOL'
        description='Mother`s Day falls on the second Sunday of May. Get exciting tips, tricks and ideas on how you can celebrate Mother`s Day with the woman in your life.'
      />} />
    <Route path='/trends/:trend(travelindaba)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/travelindaba'
        title='TravelIndaba | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(travel-indaba)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/travel-indaba'
        title='Travel Indaba2022 | Tourism | IOL'
        description="Africa’s Travel Indaba is one of the largest tourism marketing events on the African calendar and one of the top three ‘must visit’ events of its kind on the global calendar. It showcases the widest variety of Africa's best tourism products and attracts international buyers and media from across the world. Africa’s Travel Indaba is owned by South African Tourism"
      />} />
    <Route path='/trends/:trend(karabomokoena)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/karabomokoena'
        title='KaraboMokoena | Latest News, Developments & Updates | IOL'
        description='Get the latest developing news stories on the murder of Karabo Mokoena by her boyfriend, Sandile Mantsoe. Follow IOL for more on the case, verdicts and reports.'
      />} />
    <Route path='/trends/:trend(freedomday)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/freedomday'
        title='FreedomDay | Latest News, Developments & Updates | IOL'
        banner={'/images/freedom-day-2021-banner.jpg'}
        sectionLabel='none'
        description='27 April is Freedom Day in South Africa. Get the latest news updates pictures, stories and videos on the commemoration f the first post-apartheid elections held in 1994.'
      />} />
    <Route path='/trends/:trend(saftustrike)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/saftustrike'
        title='SAFTUstrike | Latest News, Developments & Updates | IOL'
        description='IOL gives you the latest news updates on The South African Federation of Trade Unions (SAFTU) Strike against the proposed national minimum wage.'
      />} />
    <Route path='/trends/:trend(mahikeng)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/mahikeng'
        title='Mahikeng | Latest News, Developments & Updates | IOL'
        description='IOL brings you the latest news story updates on the violent strike happening in Mahikeng in the North West province. Stay up-to-date with pictures, video and commentary.'
      />} />
    <Route path='/trends/:trend(afriforum)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/afriforum'
        title='AfriForum | Latest News, Developments & Updates | IOL'
        description='Get the latest news reports, political discussions and announcements on AfriForum, the Afrikaner nationalist group affiliated to the Solidarity trade union.'
      />} />
    <Route path='/trends/:trend(ripwinniemandela)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ripwinniemandela'
        title='WinnieMandela | Latest News, Developments & Updates | IOL'
        description='2nd of April 2018 the mother of the nation, Winnie Mandela Died. IOL brings you the latest in this developing story with stories, pictures, videos and opinion.'
      />} />
    <Route path='/trends/:trend(gpschooladmissions)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/gpschooladmissions'
        title='GPSchoolAdmissions | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(commonwealthgames2018)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/commonwealthgames2018'
        title='CommonwealthGames2018 | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(savaus)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/savaus'
        title='SAvAUS | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(listeriosis)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/listeriosis'
        title='Listeriosis | Latest News, Developments & Updates | IOL'
        description='Get the latest updates, news and stories on the listeriosis outbreak in South Africa. Follow #listeriosis on @IOL to see what others have to say and to share your views.'
      />} />
    <Route path='/trends/:trend(easterweekend)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/easterweekend'
        title='EasterWeekend | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(ctijf)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/ctijf'
        title='CTIJF2018 | Latest News, Developments & Updates | IOL'
        description='Be in the know with the latest celebrity and entertainment news, gossip, pics and videos from the Cape Town International Jazz Festival`s 20th anniversary.'
      />} />
    <Route path='/trends/:trend(eskominquiry)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/eskominquiry'
        title='EskomInquiry | Latest News, Developments & Updates | IOL'
        description='Follow IOL for all the latest news, comment and analysis, reports, findings and recommendations of the Eskom Inquiry by the Public Enterprises Portfolio Committee.'
      />} />
    <Route path='/trends/:trend(landexpropriation)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/landexpropriation'
        title='LandExpropriation | Latest News, Developments & Updates | IOL'
        description='Find out what the conversation is around agriculture, land expropriation an land reform with the latest news and commentary from political and economic analysts.'
      />} />
    <Route path='/trends/:trend(guptacourt)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/guptacourt'
        title='GuptaCourt | Latest News, Developments & Updates | IOL'
        description='Get the latest news, clips and pictures on the Gupta family and Vrede Vrede Dairy Farm court case. Stay up-to-date with general updates and opinion pieces on IOL.'
      />} />
    <Route path='/trends/:trend(watercrisis)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/watercrisis'
        title='WaterCrisis | Latest News, Developments & Updates | IOL'
        description='Stay up-to-date on Cape Town`s water crisis with the latest news, dam level updates, water restrictions announcements and commentary from experts.'
      />} />
    <Route path='/trends/:trend(sona2018)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/sona2018'
        title='SONA2018 | Latest News, Developments & Updates | IOL'
        description='Get news updates on the annual State of the Nation Address, where the  South African president highlights the countries achievements and challenges over the previous year.'
      />} />
    <Route path='/trends/:trend(everydropcounts)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/everydropcounts'
        title='EveryDropCounts | Latest News, Developments & Updates | IOL'
        description='IOL keeps you updated on the Western Cape water crisis that started in 2018. We give you water-saving tips, updates on dam levels and announcements from Cape Town City.'
      />} />
    <Route path='/trends/:trend(riphughmasekela)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/riphughmasekela'
        title='RIPHughMasekela | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(allistercoetzee)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/allistercoetzee'
        title='AllisterCoetzee | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(savind)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/savind'
        title='SAvIND | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(anc106)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/anc106'
        title='ANC106 | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(goldenglobes)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/goldenglobes'
        title='GoldenGlobes | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(feesmustfall)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/feesmustfall'
        title='FreeEducation | Latest News, Developments & Updates | IOL'
        description='For all latest updates on Fees Must Fall, a nationwide university student-led protest that started in 2015. Follow IOL for the latest news on the free education movement.'
      />} />
    <Route path='/trends/:trend(steinhoffscandal)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/steinhoffscandal'
        title='Steinhoffscandal | Latest News, Developments & Updates | IOL'
        description='Follow IOL for the latest news, expert analysis, updates and pictures on the Steinhoff investment and accounting irregularities debacle.'
      />} />
    <Route path='/trends/:trend(riprobbiemalinga)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/riprobbiemalinga'
        title='RIPRobbieMalinga | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend(anc-conference)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section='trends/anc-conference'
        title='ANC54 | Latest News, Developments & Updates | IOL'
        description=''
      />} />
    <Route path='/trends/:trend([a-zA-Z0-9-]+)' render={props =>
      <DefaultTrendPage {...p} {...props}
        section={'trends/' + props.match.params.trend} />} />
  </Switch>
)

export default Trends
